( function( $ ) {

$(document).ready(function(){
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};	

var ref = getUrlParameter('ref');
if (window.location.search.indexOf('ref') > -1) {
	 $('#too-many').css('display','block');
    $('input[data-pro="trial"]').removeClass('none-pointer');
}
else if($('input[data-pro="trial"]').val() > 1) {
   $('#too-many').css('display','block');
    $('input[data-pro="trial"]').removeClass('none-pointer');
}
$(window).click(function(e) {
  $('#too-many').css('display','none');
});



  
});
} )( jQuery );